/**
 * KycRepository
 *
 * Define os templates de contexto para eventos do dominio KYC (verificacao de identidade).
 * Nao importa Sentry nem executa captura - apenas retorna o objeto de contexto
 * padronizado que o ObservabilityService vai usar.
 */

const KycRepository = {
  /**
   * Template para falha ao buscar poses de validacao (POST /validation).
   * @param {{ step?: string, device?: string }} ctx
   * @returns {{ tags: object, extra: object }}
   */
  buildFetchPosesContext(ctx = {}) {
    return {
      tags: { flow: 'kyc_fetch_poses', domain: 'kyc', kyc_step: 'init' },
      extra: {
        step: ctx.step ?? 'fetch_poses',
        device: ctx.device,
      },
    };
  },

  /**
   * Template para falha no upload de video/selfie (POST /validation/upload).
   * @param {{ step?: string, isMac?: boolean, videoType?: string, hasDocFront?: boolean, hasDocBack?: boolean, device?: string }} ctx
   * @returns {{ tags: object, extra: object }}
   */
  buildVideoUploadContext(ctx = {}) {
    return {
      tags: { flow: 'kyc_video_upload', domain: 'kyc', kyc_step: 'selfie' },
      extra: {
        step: ctx.step ?? 'video_upload',
        is_mac: ctx.isMac ?? false,
        video_type: ctx.videoType,
        has_doc_front: ctx.hasDocFront ?? false,
        has_doc_back: ctx.hasDocBack ?? false,
        device: ctx.device,
      },
    };
  },

  /**
   * Template para falha ao salvar imagens do documento (PUT /user/:id).
   * @param {{ step?: string, documentType?: string, hasDocFront?: boolean, hasDocBack?: boolean, device?: string }} ctx
   * @returns {{ tags: object, extra: object }}
   */
  buildSaveImagesContext(ctx = {}) {
    return {
      tags: { flow: 'kyc_save_images', domain: 'kyc', kyc_step: 'upload' },
      extra: {
        step: ctx.step ?? 'save_images',
        document_type: ctx.documentType ?? 'identity',
        has_doc_front: ctx.hasDocFront ?? false,
        has_doc_back: ctx.hasDocBack ?? false,
        device: ctx.device,
      },
    };
  },

  /**
   * Template para falha na permissao de camera ou inicializacao de stream.
   * @param {{ step?: string, errorType?: string, device?: string, browser?: string }} ctx
   * @returns {{ tags: object, extra: object }}
   */
  buildCameraErrorContext(ctx = {}) {
    return {
      tags: { flow: 'kyc_camera', domain: 'kyc', kyc_step: 'camera' },
      extra: {
        step: ctx.step ?? 'camera_init',
        error_type: ctx.errorType,
        device: ctx.device,
        browser: ctx.browser,
      },
    };
  },
};

export default KycRepository;
